import { visit } from 'unist-util-visit';
import type { Root } from 'mdast';
import { parseGdocTableHtml } from './parseGdocTableHtml';

// Replace raw-HTML table nodes (the gdoc importer keeps tables as opaque
// single-line HTML) with structured `htmlTable` nodes whose cells hold
// ordinary mdast content — so footnote markers, links, and emphasis inside
// tables flow through the normal rendering pipeline. HTML that isn't a
// single well-formed table is left as-is and renders via the legacy
// raw-HTML path.
export function remarkHtmlTables() {
  return (tree: Root) => {
    visit(tree, 'html', (node: any, index: number | undefined, parent: any) => {
      if (!parent || index === undefined) return;
      const value = String(node.value || '');
      if (!/^\s*<table[\s>]/i.test(value)) return;
      const table = parseGdocTableHtml(value);
      if (table) parent.children[index] = table;
    });
  };
}
